/* =============================================================================
   QUICK ADD — ajout au panier depuis les cartes produit
   (collections, recherche, collections mises en avant, recommandations,
   produits vus récemment)
   Ajouté le 24/08/2026.

   Markup  : snippets/product-item.liquid (bouton [data-quick-add])
   Styles  : assets/quick-add.css
   Chargé  : layout/theme.liquid (defer, après custom.js)

   Points d'implémentation :

   - Délégation sur `document` en phase de CAPTURE. Indispensable pour deux
     raisons : (a) la grille de collection est re-rendue en AJAX au filtrage et
     au changement de layout, donc un binding direct serait perdu ; (b) dans
     sections/predictive-search.liquid la carte est enveloppée dans un div avec
     un onclick inline qui navigue vers la fiche produit — la capture puis le
     stopPropagation empêchent ce départ non désiré.

   - Après l'ajout, on rafraîchit le drawer via l'événement `cart:refresh`,
     hook officiel du thème (documenté dans assets/custom.js et déclenché par
     layout/theme.liquid), puis on l'ouvre en réutilisant le déclencheur du
     header. On ne réimplémente rien de la logique panier.

   - Les produits taggés `sell_for_men_women` portent une propriété de ligne
     `_type` (men/women) utilisée par snippets/cart-items.liquid pour choisir la
     vignette du drawer. On la transmet quand elle est présente.
   ========================================================================== */
(function () {
  'use strict';

  var BUTTON_SELECTOR = '[data-quick-add]';
  var DRAWER_ID = 'sidebar-cart';
  var DRAWER_TRIGGER_SELECTOR = '[data-action="open-drawer"][data-drawer-id="' + DRAWER_ID + '"]';
  var isBusy = false;

  if (!document.documentElement.closest || typeof window.fetch !== 'function') {
    return; // navigateur trop ancien : les tailles restent en simple affichage
  }

  function flash(button, className, duration) {
    button.classList.add(className);
    window.setTimeout(function () {
      button.classList.remove(className);
    }, duration);
  }

  function openCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // Le drawer n'est pas rendu sur le template /cart : dans ce cas on ne force rien.
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    window.setTimeout(function () {
      var trigger = document.querySelector(DRAWER_TRIGGER_SELECTOR);
      if (trigger && drawer.getAttribute('aria-hidden') !== 'false') {
        trigger.click();
      }
    }, 250);
  }

  function addToCart(button) {
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var item = { id: variantId, quantity: 1 };
    var productType = button.getAttribute('data-product-type');
    if (productType) {
      item.properties = { _type: productType };
    }

    var addUrl = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';

    isBusy = true;
    button.classList.add('is-loading');

    window.fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data && data.description ? data.description : 'HTTP ' + response.status);
          }
          return data;
        });
      })
      .then(function () {
        flash(button, 'is-added', 1500);
        openCartDrawer();
      })
      .catch(function (error) {
        // Cas le plus probable : stock épuisé entre le rendu de la page et le clic.
        console.error('[LDB quick add]', error);
        flash(button, 'is-error', 2500);
      })
      .then(function () {
        isBusy = false;
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest(BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    if (isBusy || button.classList.contains('is-loading')) return;

    addToCart(button);
  }, true);
})();
